import { render, staticRenderFns } from "./aidInventory.vue?vue&type=template&id=7a9227a0&scoped=true&"
import script from "./aidInventory.vue?vue&type=script&lang=js&"
export * from "./aidInventory.vue?vue&type=script&lang=js&"
import style0 from "./aidInventory.vue?vue&type=style&index=0&id=7a9227a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9227a0",
  null
  
)

export default component.exports